<template>
  <el-container direction="vertical">
    <app-header />
    <el-main>
      <slot></slot>
    </el-main>
    <app-footer />
  </el-container>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'AppLayout',
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>

<style lang="sass" scoped>
.el-container
  height: 100vh
  padding-top: 88px
  padding-bottom: 56px

</style>
